import axios, { AxiosRequestConfig } from 'axios-cad-nx';
import isElectron from 'is-electron';
import type { ExtraConfig, TypeBoundAxiosInstance } from '@m43/shared';
import { clientSessionId } from '~/session';
import { applyMockRequestConfig } from './interceptors/request-interceptors';

export const MOCK_API_CLIENT_TIMEOUT = 600;

export function createMockApiClient(): TypeBoundAxiosInstance {
    const instance = axios.create({
        baseURL: `/cad/api/`,
        timeout: MOCK_API_CLIENT_TIMEOUT,
        headers: {
            'x-cad-app-mode': isElectron() ? 'ELECTRON' : 'WEB',
            'x-application-name': 'cad-next',
            'x-client-session-id': clientSessionId,
        },
    }) as TypeBoundAxiosInstance;

    instance.interceptors.request.use(
        (config: AxiosRequestConfig & ExtraConfig) => applyMockRequestConfig(config),
        undefined
    );

    return instance;
}
